import * as React from 'react';

import type { AddressModel } from 'ab-viewModels/scheduleBoardWorkOrderModal.viewModel';

import { generateWorkLocationAddressStringIdentifier } from 'af-utils/workOrderModal.util';

import Tooltip from 'af-components/Tooltip';

import Address from './Address';

interface OwnProps {
	addresses: Nullable<AddressModel[]>;
	removedAddressesDictionary?: { [addressStringIdentifier: string]: boolean; };
}

type Props = OwnProps;

const AddressList: React.FC<Props> = (props) => {
	const { addresses = [], removedAddressesDictionary = {} } = props;

	const renderAddress = React.useCallback((address: AddressModel, index: number) => {
		const removed = removedAddressesDictionary?.[generateWorkLocationAddressStringIdentifier(address)];

		if (removed) {
			return (
				<Tooltip key={`workLocationTooltip#${index}`} message="Removed" placement="right">
					<div> {/* empty div is necessary for tooltip to work properly */}
						<Address
							address={address}
							isRemoved={removed}
						/>
					</div>
				</Tooltip>
			);
		}

		return (
			<Address
				address={address}
				key={`address-${index}`}
			/>
		);
	}, [removedAddressesDictionary]);

	if (!addresses?.length) {
		return (
			<span className="no-data-label">No work locations available</span>
		);
	}

	return addresses.map(renderAddress);
};

export default React.memo(AddressList);
